export default "__VITE_ASSET__CiNgbJN___"